export default __webpack_public_path__ + "static/media/motorcycle_light.00f75043.png";